import { useEffect, useState } from 'react';

// Replace with your Finnhub API key
const FINNHUB_API_KEY = process.env.FINNHUB_API_KEY;

interface RealTimePrice {
  symbol: string;
  price: number;
  timestamp: number;
}

export const useRealTimeStockPrice = (symbol: string) => {
    const [priceData, setPriceData] = useState<RealTimePrice | null>(null);
  
    useEffect(() => {
        const socket = new WebSocket(`wss://ws.finnhub.io?token=${FINNHUB_API_KEY}`);
      
        const subscribe = () => {
          if (socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify({ type: 'subscribe', symbol }));
          }
        };
      
        // If the socket is still connecting, wait for the open event
        socket.addEventListener('open', subscribe);
      
        // Listen for messages
        socket.addEventListener('message', (event) => {
          const data = JSON.parse(event.data);
          if (data.type === 'trade' && data.data) {
            const latestTrade = data.data[0];
            setPriceData({
              symbol: latestTrade.s,
              price: latestTrade.p,
              timestamp: latestTrade.t,
            });
          }
        });
      
        socket.addEventListener('error', (err) => {
          console.error('WebSocket error:', err);
        });
      
        return () => {
          if (socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify({ type: 'unsubscribe', symbol }));
          }
          socket.close();
        };
      }, [symbol]);
  
    return priceData;
  };

export interface CandleData {
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  time: string; // ISO string
}

export const fetchHistoricalCandles = async (
  symbol: string,
  timeframe: '1m' | '5m' | '15m' | '1h' | '1d' = '1d'
): Promise<CandleData[]> => {
  // Mock data for now; replace with real API call in production
  await new Promise(resolve => setTimeout(resolve, 500));
  return [
    { open: 172.5, high: 174.0, low: 171.0, close: 173.5, volume: 1000000, time: '2025-08-20T00:00:00Z' },
    { open: 173.5, high: 175.2, low: 172.8, close: 174.8, volume: 1200000, time: '2025-08-21T00:00:00Z' },
    { open: 174.8, high: 176.0, low: 173.5, close: 175.0, volume: 1100000, time: '2025-08-22T00:00:00Z' },
  ];
};